import React, { useState } from "react";

const CompanyHomeTab = ({ organization }) => {
  // State to control whether to show full content
  const [showFullDetails, setShowFullDetails] = useState(false);
  const description = organization?.content?.en?.content;
  // Shortened description and full description
  const shortDescription =
    "Pacto is dedicated to improving health outcomes by enabling patients and healthcare providers to make informed decisions. The platform leverages computer science and data science to ensure that every interaction contributes to better health outcomes.";
  const fullDescription =
    "Pacto is dedicated to improving health outcomes by enabling patients and healthcare providers to make informed decisions. The platform leverages computer science and data science to ensure that every interaction contributes to better health outcomes. Founded 17 years ago, Practo is a homegrown Indian healthcare startup that offers health services, including online doctor consultations, booking appointments, pharmacy services, diagnostics, and more. Today, Practo is one of the leading healthtech platforms in India, operating across multiple countries and helping millions of people access quality healthcare.";
  return (
    <div>
      <div className="p-4 border rounded-lg bg-white shadow-md">
        {/* Title */}
        <h3 className="text-base font-semibold text-gray-800">Overview</h3>

        {/* Description (short or full based on state) */}
        <p className="text-gray-600 mt-2 text-sm">
          {showFullDetails ? description : description?.slice(0, 200)}
        </p>

        {/* Button to toggle between showing all or partial details */}
        {description?.length > 200 && (
          <button
            onClick={() => setShowFullDetails((prev) => !prev)}
            className="mt-4 text-sm text-blue-600 hover:underline"
          >
            {showFullDetails ? "Show less" : "Show all details →"}
          </button>
        )}
      </div>
    </div>
  );
};

export default CompanyHomeTab;
